import { render, staticRenderFns } from "./ItemFilterCurationRequestFilter.vue?vue&type=template&id=4e458c37&scoped=true"
import script from "./ItemFilterCurationRequestFilter.vue?vue&type=script&lang=js"
export * from "./ItemFilterCurationRequestFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e458c37",
  null
  
)

export default component.exports